module.exports = __webpack_public_path__ + "img/fushimi-HP-016.c825db8d.jpg";